// extracted by css-extract-rspack-plugin
export default {"hero":"Hero-module__hero","title":"Hero-module__title","lede":"Hero-module__lede","subtitle":"Hero-module__subtitle"};